export const SET_FEATURE_PROPERTIES_BATCH= 'SET_FEATURE_PROPERTIES_BATCH';
export const FETCH_FEATURE_PROPERTIES_REQUEST = 'FETCH_FEATURE_PROPERTIES_REQUEST';
export const FETCH_FEATURE_PROPERTIES_SUCCESS = 'FETCH_FEATURE_PROPERTIES_SUCCESS';
export const FETCH_FEATURE_PROPERTIES_FAILURE = 'FETCH_FEATURE_PROPERTIES_FAILURE';